/**
 * Project Health Status Constants
 *
 * Centralized definitions for the deal project-health fields
 * (schedule_status, budget_status, scope_status, alignment_status).
 * Keep in sync with Postgres `project_health_status` enum
 * (see supabase/migrations/20260221000002_add_project_health_to_deals.sql).
 */

import type { ProjectHealthStatus } from "@/lib/types/database/deals";

/** Tuple for Zod `z.enum()` — must match Postgres `project_health_status`. */
export const PROJECT_HEALTH_STATUS_VALUES = [
  "green",
  "yellow",
  "red",
] as const satisfies readonly ProjectHealthStatus[];

/** The four project-health dimensions tracked on a deal. */
export const PROJECT_HEALTH_FIELDS = [
  "schedule_status",
  "budget_status",
  "scope_status",
  "alignment_status",
] as const;

export type ProjectHealthField = (typeof PROJECT_HEALTH_FIELDS)[number];

export function isProjectHealthStatus(value: string): value is ProjectHealthStatus {
  return (PROJECT_HEALTH_STATUS_VALUES as readonly string[]).includes(value);
}
